<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_b2b_nav',
		availableFor: ['pages'],
		query: gql`
        internal_name
        translations {
            languages_code {
                code
            }
            section_title
            title
            text
        }
        items {
            section_b2b_nav_item_id {
                link {
                    ...Link
                }
            }
        }



    `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		section_title: string;
		title: string;
		text: string;
		items: any;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section gapType="padding" class="section-b2b">
	<div slot="background" class="background" />
	<div class="wrapper">
		<div>
			<div class="section-title">{data.section_title}</div>
			<div class="title">{data.title}</div>
		</div>
		<div class="text"><Wysiwyg text={data.text} /></div>
	</div>
	<div class="buttons">
		{#each data.items as { section_b2b_nav_item_id: item }}
			<DirectusLink {...item.link}>
				<Button {...item.link} variant="outline" />
			</DirectusLink>
		{/each}
	</div>
</Section>

<style lang="scss">
	:global(.section-b2b) {
		:global(.background) {
			background: color(yellow);
		}
	}
	.wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: v(content-gap-sm);
	}
	.section-title {
		@include font(h6);
		text-align: center;
		margin-bottom: v(content-gap-xs);
	}
	.title {
		@include font(h2);
		text-align: center;
	}
	.text {
		@include font(text);
		max-width: 80ch;
		text-align: center;
	}
	.buttons {
		margin-top: v(content-gap-sm);
		display: flex;
		justify-content: center;
		gap: v(content-gap-sm);
		flex-wrap: wrap;
		:global(button) {
			color: color(yellow);
			cursor: pointer;
			&:hover {
				background: color(black) !important;
				color: color(yellow) !important;
				border: solid 1px color(black) !important;
			}
		}
	}
</style>
